export default function initializeBrands() {
  document.querySelectorAll('.block-brands').forEach(function(block) {
    const categories = block.querySelectorAll('.brands-categories__button');
    const items = block.querySelectorAll('.brands-list__item');

    categories.forEach(function(item) {
      item.addEventListener('click', function(e) {
        let index = item.dataset.index;
        categories.forEach(i => i.classList.remove('brands-categories__button--active'));
        items.forEach(i => i.classList.remove('brands-list__item--active'));
        item.classList.add('brands-categories__button--active');
        block.querySelector('.brands-list__category--active').classList.remove('brands-list__category--active');
        block.querySelector('.brands-list__category[data-index="' + index + '"]').classList.add('brands-list__category--active');
      });
    });

    items.forEach(function(item) {
      item.addEventListener('click', function(e) {
        let status = item.classList.contains('brands-list__item--active');
        let delay = 0;
        if (status) {
          item.classList.remove('brands-list__item--active');
        } else {
          var otherActivated = block.querySelectorAll('.brands-list__item--active');
          if (otherActivated.length > 0) {
            delay = 300;
            otherActivated.forEach(i => i.classList.remove('brands-list__item--active'));
          }
          setTimeout(function() {
            if (!item.classList.contains('brands-list__item--no-desc')) {
              item.classList.add('brands-list__item--active');
            }
          }, delay);
        }
      });
    });
  });
}